// extracted by mini-css-extract-plugin
module.exports = {"LbCompareDashboardCol":"LbCompareDashboardCol_tu5Qp"};